import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class AppModeService {
    constructor(private readonly activatedRoute: ActivatedRoute) {}

    isAppMode(): boolean {
        const paramValue = this.activatedRoute.snapshot.queryParamMap.get('mode');
        return paramValue === 'app';
    }
}
